// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: '',
  useHash: true,
  apiUrl: 'https://test.sssacc.xyz/server/api',
  onlyUrl: 'https://test.sssacc.xyz/server',
  authApi: ''
};

/*
  apiUrl: 'https://mob.shivshaktisoftware.com/server/api',
  onlyUrl: 'https://mob.shivshaktisoftware.com/server',

  apiUrl: 'https://moblive.shivshaktisoftware.com/server/api',
  onlyUrl: 'https://moblive.shivshaktisoftware.com/server',

    apiUrl: 'https://test.sssacc.xyz/server/api',
  onlyUrl: 'https://test.sssacc.xyz/server',

  apiUrl: 'http://localhost:3002/api',
  onlyUrl:'http://localhost:3002',
apiUrl: 'https://biz.sssacc.xyz/api/webapi.aspx',
  onlyUrl:'https://biz.sssacc.xyz',
 apiUrl: 'https://api.marutidecor.com/api',
  onlyUrl:'https://api.marutidecor.com',
  apiUrl: 'http://localhost:3001/api',
  onlyUrl:'http://localhost:3001',
  apiUrl: 'https://co.sssacc.xyz/api',
  onlyUrl:'https://co.sssacc.xyz',
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
